import React, { FC } from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { Globe, Premium } from '@wix/wix-ui-icons-common';
import { useUpgradePlan } from '../hooks/useUpgradePlan';
import { useViewSite } from '../hooks/useViewSite';
import { CardLayout } from '../../../components/layouts/CardLayout';
import { Dot } from '../../../components/Dot/Dot';
import { UpgradeButton } from './UpgradeButton';
import { PromotionalOffer } from '../components/PromotionalOffer';
import s from './SideContent.scss';
import { useSpec } from '../../../hooks/useSpec';
import { Off50YearlyOffer } from '../../../experiments';

const FeautureText = ({ value }: { value: string }) => {
  return (
    <Box direction="horizontal" align="center" verticalAlign="middle" gap={2}>
      <Dot color="#8C6BFF" />
      <Text className={s.featureText}>{value}</Text>
    </Box>
  );
};

export const SideContent: FC = () => {
  const { t } = useTranslation();
  const { upgradePlan, isLoading: isUpgradeLoading } = useUpgradePlan();
  const { viewLiveSite, isViewLoading } = useViewSite();
  const isOff50YearlyOffer = useSpec(Off50YearlyOffer);

  const handleGetOffer = () => {
    upgradePlan();
  };

  const handleCopyCode = async (couponCode: string) => {
    await navigator.clipboard.writeText(couponCode);
  };

  return (
    <Box direction="vertical" gap={6} width="100%">
      {isOff50YearlyOffer && <PromotionalOffer onGetOffer={handleGetOffer} onCopyCode={handleCopyCode} />}

      <CardLayout>
        <Box direction="vertical" gap={3}>
          <Box direction="vertical" gap={1}>
            <Text>{t('CURRENT_PLAN')}:</Text>

            <Text weight="bold">{t('FREE_PLAN')}</Text>
          </Box>

          <UpgradeButton onClick={upgradePlan} disabled={isUpgradeLoading} />
        </Box>
      </CardLayout>

      <CardLayout>
        <Box direction="vertical" gap={3}>
          <Text weight="bold" className={s.unlockTitle}>
            {t('site_preview.features.header')}
          </Text>

          <Box direction="vertical" align="left" gap={3}>
            <FeautureText value={t('site_preview.features.content_1')} />

            <FeautureText value={t('site_preview.features.content_2')} />

            <FeautureText value={t('site_preview.features.content_3')} />
          </Box>
        </Box>
      </CardLayout>

      <Box direction="vertical" gap={2}>
        {isOff50YearlyOffer ? (
          <PromotionalOffer
            variant="button"
            onGetOffer={upgradePlan}
            onCopyCode={handleCopyCode}
            disabled={isUpgradeLoading}
          />
        ) : (
          <Button
            size="medium"
            skin="premium"
            width="100%"
            onClick={upgradePlan}
            disabled={isUpgradeLoading}
            prefixIcon={<Premium />}
          >
            {t('UPGRADE_NOW')}
          </Button>
        )}

        <Button
          size="medium"
          skin="inverted"
          width="100%"
          onClick={viewLiveSite}
          disabled={isViewLoading}
          prefixIcon={<Globe />}
        >
          {t('VIEW_LIVE_SITE')}
        </Button>
      </Box>
    </Box>
  );
};
